/** Helper chunk to get the PCF soft shadow generated by all the {@link core/lights/DirectionalLight.DirectionalLight | DirectionalLight}, {@link core/lights/PointLight.PointLight | PointLight} and {@link core/lights/SpotLight.SpotLight | SpotLight}. */
export const getPCFShadows: string = /* wgsl */ `
  let pointShadows = getPCFPointShadows(worldPosition, fragmentPosition.xy);
  let directionalShadows = getPCFDirectionalShadows(worldPosition, fragmentPosition.xy);
  let spotShadows = getPCFSpotShadows(worldPosition, fragmentPosition.xy);
`
